import { useState, useEffect } from 'react';

async function getUser() {
  const response = await fetch('/api/currentuser', { credentials: 'include' })
  try {
      const usr = await response.json()
      return usr
  } catch (e) {
      return null
  }
}

export default function useUser() {
  const [user, setUser] = useState([]);
  useEffect(() => {
      getUser().then((usr) => setUser(usr || {}))
  }, []);
  return user
}